export const handleErrors = (response: Response) => {
    if (!response.ok) {
        console.error(`Network Response: ${response.statusText}`)
        throw Error(response.statusText);
    }
    return response;
}
